import React, { Component } from 'react';
import { Table } from 'reactstrap';
import i18n from '../../../../i18next';

import {
    transformProductPrice,
    getPriceWithCurrencySymbol
} from '../../../../utils/CommonUtils';

class RefundHistoryTable extends Component {
    renderRefundHistory(refunds) {
        const currency = this.props.currency ? this.props.currency : this.props.orderDetails.order.currency;

        return refunds.map((refund) => {
            const refundType = refund.refundType === 'GIFT_CARD' ? i18n.t('screens:orderHistoryScreen.giftCard') : i18n.t('screens:orderHistoryScreen.creditCard');
            const refundAmount = transformProductPrice(refund.amount);
            const refundAmountWithCurrency = getPriceWithCurrencySymbol(refundAmount, currency);
            
            return (
                <tr className="d-flex">
                    <td className="col-3">{refund.date}</td>
                    <td className="col-2">{refundAmountWithCurrency}</td>
                    <td className="col-2">{refundType}</td>
                    <td className="col-5">{refund.reason}</td>
                </tr>
            );
        });
    }

    render() {
        const refunds = this.props.orderDetails.refunds;

        return (
            <Table responsive>
                <thead>
                    <tr className="d-flex">
                        <th className="col-3">{i18n.t('screens:orderHistoryScreen.date')}</th>
                        <th className="col-2">{i18n.t('screens:orderDetailsScreen.amount')}</th>
                        <th className="col-2">{i18n.t('screens:orderHistoryScreen.type')}</th>
                        <th className="col-5">{i18n.t('screens:orderDetailsScreen.reason')}</th>
                    </tr>
                </thead>
                <tbody>
                    {(refunds.length > 0) ? this.renderRefundHistory(refunds) : <p style={{ padding: 12 }}>{i18n.t('screens:orderDetailsScreen.noRefundHistory')}</p>}
                </tbody>
            </Table>
        )
    }
}

export default RefundHistoryTable;


// WEBPACK FOOTER //
// ./src/components/restaurants/orders/orderDetailsCommon/RefundHistoryTable.js